import React, { useState } from 'react'
import ClickAwayHandler from '../ClickAwayHandler'
import './DropDown.scss'

const DropDown = ({
  children,
  className = '',
  dropDownClassName = '',
  renderTrigger,
  renderChildren,
  onClickAway=() => null
}) => {
  const [isOpen, setIsOpen] = useState(false)

  const toggleOpen = (e) => {
    e.preventDefault()
    setIsOpen(!isOpen)
  }

  return (
    <ClickAwayHandler
      handleClickAway={() => {
        setIsOpen(false)
        onClickAway()
      }}
      className={className}
    >
      <>
        {renderTrigger({ isOpen, toggleOpen })}
        {isOpen ? (
          <div className={`DropDown ${dropDownClassName}`}>
            {renderChildren ? renderChildren({ isOpen, toggleOpen }) : children}
          </div>
        ) : null}
      </>
    </ClickAwayHandler>
  )
}

export default DropDown
